import { ComponentPropsWithRef } from "react";

export const ShareIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.5487 33.9708C20.8907 36.6025 16.565 36.6025 13.906 33.9708C11.2469 31.3391 11.2688 27.0769 13.9268 24.4451L14.0458 24.3273C14.2391 24.1359 14.2391 23.8247 14.0458 23.6333L11.939 21.5474C11.7456 21.356 11.4314 21.356 11.238 21.5474L11.2043 21.5807C7.00556 25.7379 6.90245 32.5052 11.0764 36.686C15.2672 40.8834 22.127 40.8981 26.3367 36.7302L32.0632 31.0603C32.2566 30.8689 32.2566 30.5577 32.0632 30.3663L29.9653 28.2892C29.771 28.0968 29.4567 28.0978 29.2634 28.2892L23.5487 33.9708ZM36.8102 11.206C32.5877 7.07332 25.7527 7.17541 21.554 11.3326L15.9117 16.919C15.7183 17.1104 15.7183 17.4216 15.9117 17.613L18.0096 19.6901C18.2039 19.8825 18.5182 19.8816 18.7115 19.6901L24.4262 14.0095C27.0842 11.3777 31.4099 11.3777 34.0689 14.0095C36.727 16.6412 36.7052 20.9024 34.0471 23.5352L33.9281 23.653C33.7348 23.8444 33.7348 24.1556 33.9281 24.347L36.0349 26.4329C36.2283 26.6243 36.5426 26.6243 36.7359 26.4329L36.8539 26.3161C41.0635 22.1481 41.0487 15.3573 36.8093 11.2069L36.8102 11.206Z"
      fill="currentColor"
    />
    <path
      d="M28.4951 16.7485L16.6725 28.454C16.479 28.6457 16.479 28.9565 16.6725 29.1481L18.7757 31.2305C18.9693 31.4222 19.2832 31.4222 19.4768 31.2305L31.2993 19.525C31.4929 19.3333 31.4929 19.0225 31.2993 18.8308L29.1962 16.7485C29.0026 16.5568 28.6887 16.5568 28.4951 16.7485Z"
      fill="currentColor"
    />
  </svg>
);
